import { LANGUAGE_MAP } from "@/utils/const";

/**
 * find the prefix style for the testGroupNode
 * @param { Object } testGroupNode - the testGroup(root) item
 * @param { Array } descendants - descendants of the testGroup
 * @param { String } selectProp - "isSelect", "isSelectForShortcut", etc
 * @returns { String } - "allCheck", "partCheck", "unCheck"
 */
export function getTestCardPrefix(testGroupNode, descendants, selectProp) {
  if (descendants.length === 0) {
    return testGroupNode.value[selectProp] ? "allCheck" : "unCheck";
  }
  let selectedTestNumber = descendants.filter(p => p.value[selectProp]).length;
  // for non breakable item
  if (testGroupNode.value.notBreakable) {
    // if itself is checked, return "allCheck"
    if (testGroupNode.value[selectProp]) {
      return "allCheck";
    }
    // if itself is not selected, check whether any of its children are selected
    // if at least one child is selected, return "partCheck", otherwise, return "unCheck"
    return selectedTestNumber > 0 ? "partCheck" : "unCheck";
  }
  // for other normal testGroup item
  return selectedTestNumber === 0 // no test in testGroup is selected
    ? "unCheck"
    : selectedTestNumber < descendants.length // select part of tests in testGroup
    ? "partCheck"
    : "allCheck"; // all tests in testGroup are selected
}

/**\
 * get the item name by language
 * @param { Object } item - va, vw, or discount panel item
 * @param { String } languageCode - the 2 letter language code
 * @returns { String } - the item name in the chosen language
 */
export function getItemNameByLanguage(item, languageCode) {
  let language = LANGUAGE_MAP[languageCode];
  if (item.names && item.names[language]) {
    return item.names[language];
  }
  return ["va", "vw"].includes(item.category) ? item.testName : item.bundleName;
}